import React from "react";
import styled from "styled-components";
import OnlineStatus from "../../OnlineStatus";
import Avatar from "../../Avatar";
import CheckBox from "../../CheckBox";
import AtUsername from "../../AtUsername";
import { Contact } from "../../../models";

const ContactListItemWrap = styled.div`
  position: relative;
  display: flex;
  background-color: ${({ theme }) => theme.colors.blockBackground};
  padding: ${({ theme }) => theme.space[2]} ${({ theme }) => theme.space[4]} }
  border: 0px solid ${({ theme }) => theme.colors.border};
  border-bottom-width: 1px;
  cursor: pointer;
`;

const CheckWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: ${({ theme }) => theme.space[3]};
`;

const Main = styled.div`
  margin-left: 5px;
  width: calc(100% - 40px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

const Title = styled.div`
  font-size: 0.8rem;
`;

interface Props {
  checked?: boolean;
  item: Contact;
  onItemPress?: (contact: Contact) => void;
}

const ContactListItem: React.FC<Props> = ({ checked, item, onItemPress }) => {
  return (
    <ContactListItemWrap onClick={() => onItemPress(item)}>
      {checked !== void 0 && (
        <CheckWrap>
          <CheckBox checked={checked} value={item.user.id} />
        </CheckWrap>
      )}
      <Avatar avatar={item.user.avatar} name={item.displayName} />
      <Main>
        <Column>
          <Title>
            {item.displayName}
            <AtUsername user={item.user} />
          </Title>
          <OnlineStatus
            last_seen={item.user.last_seen}
            online={item.user.online}
          />
        </Column>
      </Main>
    </ContactListItemWrap>
  );
};

export default ContactListItem;
